import { getSessionStore, curHouseInfo_key, isShowHouse_key } from "../utils/localCache";


export default {
    getCurHouseInfo: state => {
        if (state.curHouseInfo.gatewayId == undefined) {
            state.curHouseInfo = JSON.parse(getSessionStore(curHouseInfo_key));
        }
        return state.curHouseInfo;
    },
    getShouldShowHouse: state => {
        state.isShowHouse = getSessionStore(isShowHouse_key) == 'false' ? false : true;
        return state.isShowHouse;
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js